export const ModuleType = {
  SCORM: 0,
  LEARNWARE: 1
};
